module.exports = __webpack_public_path__ + "static/media/swipeleft.6fde0614.png";